import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
import RangeBar from '@/materials/molecules/RangeBar.vue';
import ClearButton from '@/materials/molecules/ClearButton.vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    emits: ["click"],
    setup(__props, { emit }) {
        const resetKey = ref(0);
        const onChangeRange = (value) => {
            emit('click', value);
            if (value === 0) {
                resetKey.value = resetKey.value === 0 ? 1 : 0;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(ClearButton, {
                    class: "button",
                    onClick: _cache[0] || (_cache[0] = ($event) => (onChangeRange(0)))
                }),
                (_openBlock(), _createBlock(RangeBar, {
                    class: "bar",
                    onClick: onChangeRange,
                    key: resetKey.value
                }))
            ]));
        };
    }
});
